import {Pocket} from "./types";

export function formatAmount(amount: number): string {
  return `€${Math.floor(amount)}`
}

export function buildPocketInfo(
  pockets: Array<Pocket>,
  mainPocketId: string,
  fromPocketId?: string,
  toPocketId?: string,
): string | undefined {

  const defaultPocket: string = "покет"
  const fromPocket: string = (fromPocketId ? pockets.find(pocket => pocket.id === fromPocketId)?.title : defaultPocket) ?? defaultPocket
  const toPocket: string = (toPocketId ? pockets.find(pocket => pocket.id === toPocketId)?.title : defaultPocket) ?? defaultPocket

  if (fromPocketId === mainPocketId) {
    fromPocketId = undefined
  }

  if (toPocketId === mainPocketId) {
    toPocketId = undefined
  }

  if (fromPocketId && toPocketId) {
    return `из покета ${fromPocket} в покет ${toPocket}`
  }
  if (fromPocketId) {
    return `из покета ${fromPocket}`
  }
  if (toPocketId) {
    return `в покет ${toPocket}`
  }
  return undefined
}

export interface ChangePocketData {
  fromPocket: string
  toPocket: string
  lastFromPocket: string
  lastToPocket: string
}

export function changePocket(d: ChangePocketData): ChangePocketData {
  const res: ChangePocketData = {...d}

  if (d.fromPocket && d.toPocket && d.fromPocket === d.toPocket) {
    if (d.lastFromPocket !== d.fromPocket) {
      res.toPocket = d.lastFromPocket;
    } else {
      res.fromPocket = d.lastToPocket;
    }
  }
  res.lastToPocket = res.toPocket;
  res.lastFromPocket = res.fromPocket;
  return res;
}

export function loadIsLoggedIn(): boolean {
  return loadAccessToken() != null
}

export function removeAccessToken() {
  localStorage.removeItem('accessToken');
}

export function saveAccessToken(accessToken: string) {
  localStorage.setItem('accessToken', accessToken)
}

export function loadAccessToken(): string | null {
  return localStorage.getItem('accessToken')
}
